import { render, staticRenderFns } from "./SecurityManagerPrivilege.vue?vue&type=template&id=0c888028&scoped=true&"
import script from "./SecurityManagerPrivilege.vue?vue&type=script&lang=js&"
export * from "./SecurityManagerPrivilege.vue?vue&type=script&lang=js&"
import style0 from "./SecurityManagerPrivilege.vue?vue&type=style&index=0&id=0c888028&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c888028",
  null
  
)

export default component.exports